import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";
import { DashboardItemTypes, MenuOptions, ParamaterType } from "../types";

export interface DashboardItemSettings extends Dictionary<string, any>
{
    itemTypeDisplayName: string;
    isPreview: boolean;
    isOnDashboard: boolean;
    title: string;
    showRecordCount: boolean;
    recordCount: number;
    height: number;
    width: number;
    xPosition: number;
    yPosition: number;
    displayOrder: number;
    typeCode: DashboardItemTypes;
    parameters: ParamaterType;
    configurationPostData: object;
    backingModule: string | undefined;
    backingDataModule: string | undefined;
    backingObject: string | undefined;
    backingDataObject: string | undefined;
    backingScreen: string | undefined;
    backingTab: string | undefined;
    backingController: string | undefined;
    backingPrimaryKey: number | undefined;
    backingBrowseName: string | undefined;
    availableMenuOptions: MenuOptions[];
    supportedSizes: string[];
}

export const settings: StoreFeature<DashboardItemSettings> = {}
